<template>
  <div class="MenuLine">
    <table align="center" width="84%" height="60px" border="0">
      <tr>
        <td id="R1"><div class="Rbt">Обучение<br/>фасилитации</div></td>
        <td id="R2"><div class="Rbt Link" @click="goTo('home')">Библиотека<br/>фасилитатора</div></td>
        <td id="R3"><div class="Rbt">Лаборатория<br/>фасилитатора</div></td>
        <td id="R4">
          <UserBlock />
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
import UserBlock from "@/components/UserBlock.vue";

export default {
  components: {
    UserBlock
  },
};
</script>

<style>
.MenuLine {
  position: relative;
  top: 0px;
  left: 0px;
  min-width: 1300px;
  width: 100%;
  height: 60px;
  /*border-top: 15px solid #000000; */
  border-bottom: 1px solid #ccc;
  background-color: #323938;
  /* background-image: url("../img/menu-9.png");
  background-position: center;
  background-repeat: no-repeat; */
  z-index: 5;
}

.MenuLineDown {
  position: relative;
  top: 0px;
  left: 0px;
  min-width: 1300px;
  width: 100%;
  height: 60px;
  /* border-bottom: 15px solid #000000; */
  border-top: 1px solid #ccc;
  background-color: #000;
  /* background-image: url("../img/menu-9.png");
  background-position: center;
  background-repeat: no-repeat; */
  z-index: 5;
}

#R1 {
  border-left: 1px solid #595e5d;
}
#R2 {
  border-left: 1px solid #595e5d;
}
#R3 {
  border-left: 1px solid #595e5d;
  /* border-right: 1px solid #ccc; */
}
#R4 {
  border-left: 1px solid #595e5d;
  border-right: 1px solid #595e5d;
}

.Rbt {
  width: 230px;
  height: 40px;
  padding-left: 40px;
  padding-top: 3px;
  font-family: 'Roboto Condensed', sans-serif;
  font-size: 16px;
  line-height: 1.2;
  color: #838383;
  font-weight: normal;
  border: 0px solid #ccc;
}
.Rbt.Link {
  cursor: pointer;
}

.Rbt.Link:hover {
  color: #ffffff;
}
</style>
